import { clsx } from "clsx";
import { motion } from "framer-motion";
import type { MaritimeGrade } from "@/hooks/useMaritimeQualifications";

type Props = {
  value: MaritimeGrade | null;
  onChange: (grade: MaritimeGrade) => void;
  gradeNames: Record<MaritimeGrade, string>;
};

const grades: MaritimeGrade[] = [1, 2, 3, 4, 5, 6];

export const GradeSelector = ({ value, onChange, gradeNames }: Props) => {
  return (
    <div className="mb-5">
      <span className="mb-3 block font-semibold text-ocean-800 text-sm">級を選択</span>
      <div className="grid grid-cols-3 gap-3">
        {grades.map((grade) => {
          const isSelected = value === grade;
          return (
            <motion.button
              key={grade}
              type="button"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className={clsx(
                "relative cursor-pointer rounded-xl border-2 bg-white p-4 font-semibold text-base transition-all duration-200",
                isSelected
                  ? "border-ocean-500 bg-ocean-50 text-ocean-700 shadow-card"
                  : "border-ocean-200 text-ocean-600 hover:border-ocean-400 hover:bg-ocean-50/50",
              )}
              onClick={() => onChange(grade)}
            >
              {gradeNames[grade]}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};
